import { useState } from "preact/hooks"

import { api_fetch } from "@/api/client.tsx"
import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { toast } from "@/components/ui/use-toast"
import { loadOrgSettings, useOrgSettings } from "@/org_settings/state"

/** Org admins: keep the accounting pages from everyone whose team is Sales. */
export function HideAccountingFromSalesSetting() {
  const settings = useOrgSettings()
  const [saving, set_saving] = useState(false)

  async function save(hide_accounting_from_sales: boolean) {
    set_saving(true)
    const res = await api_fetch("/organization/hide-accounting-from-sales", {
      method: "POST",
      body: { hide_accounting_from_sales },
    })
    if (res.ok) {
      await loadOrgSettings()
    } else {
      toast({ title: "Could not save", description: res.error.message, variant: "destructive" })
    }
    set_saving(false)
  }

  return (
    <div class="flex items-start gap-3">
      <Switch
        id="hide-accounting-from-sales"
        checked={!!settings.hide_accounting_from_sales}
        disabled={saving}
        onCheckedChange={save}
      />
      <div>
        <Label htmlFor="hide-accounting-from-sales">Hide accounting pages from the Sales team</Label>
        <p class="mt-1 text-sm text-gray-500">
          People whose team is Sales (Settings, Users) keep Deductions but stop seeing Transactions, Cash
          application, Open deductions, File imports and the accounting settings. To let someone see them, give
          that person another team. Org admins always see everything. This tidies navigation; it is not a
          permission on the data itself.
        </p>
      </div>
    </div>
  )
}
